export const ADD_ORAGANIZATION = 'add-organization';
export const ADD_ORAGANIZATION_RESULT = `${ADD_ORAGANIZATION}/result`;
export const ADD_ORAGANIZATION_ERROR = `${ADD_ORAGANIZATION}/error`;

export const UPDATE_ORAGANIZATION = 'delete-organizations';
export const UPDATE_ORAGANIZATION_RESULT = `${UPDATE_ORAGANIZATION}/result`;
export const UPDATE_ORAGANIZATION_ERROR = `${UPDATE_ORAGANIZATION}/error`;

export const UPDATE_ORG_TYPE = 'update-organization-type';
export const UPDATE_ORG_TYPE_RESULT = `${UPDATE_ORG_TYPE}/result`;
export const UPDATE_ORG_TYPE_ERROR = `${UPDATE_ORG_TYPE}/error`;

export const GET_ORG_TYPES = 'get-organization-types';
export const GET_ORG_TYPES_RESULT = `${GET_ORG_TYPES}/result`;
export const GET_ORG_TYPES_ERROR = `${GET_ORG_TYPES}/error`;

export const GET_ORG_CLIENTS = 'get-organization-clients';
export const GET_ORG_CLIENTS_RESULT = `${GET_ORG_CLIENTS}/result`;
export const GET_ORG_CLIENTS_ERROR = `${GET_ORG_CLIENTS}/error`;

export const CLEAR_PATIENT = 'clear-patient';
